
import {
    HttpWarehouseListGetList,
    HttpExportManageWare,
    HttpWarehouseListEditConfig,
    HttpWarehouseListGetDetail
} from '@/service/basicdata';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import mixin from "../manageware/mixin";
import compUpdate from "./update.vue";
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpWarehouseListGetList,
        async handleOperates(params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        show: true,
                        title: "查看",
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: "query",
                        showFooter: false,
                    };
                    break;
                case "queryBlank":
                    let url = this.$router.resolve({
                        name: "basicdataWarehouseListUpdate",
                        params: { type: "query" },
                        query: { id: params }
                    });
                    window.open(url.href, "_blank");
                    break;
                case "edit":
                    let scpEnable = "N";
                    let isLabelBefore = '';
                    let isAttachHandling = '';
                    let shipPriority = 0;
                    let apiParams = '';
                    await HttpWarehouseListGetDetail({
                        id: params
                    }).then(res => {
                        scpEnable = res.data.warehouseBaseInfo.scpEnable;
                        isLabelBefore = res.data.warehouseBaseInfo.isLabelBefore;
                        isAttachHandling = res.data.warehouseBaseInfo.isAttachHandling;
                        shipPriority = res.data.warehouseBaseInfo.shipPriority;
                        apiParams = res.data.warehouseBaseInfo.apiParams;
                    }, err => {
                        this.$VMessage.error(err.message);
                    });
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: {
                            id: params
                        },
                        title: this.$t('fbb.warehouse.edit_warehouse', { defaultValue: '编辑仓库配置'}),
                        showDesc: false,
                        width: 460,
                        formdata: [
                            {
                                label: this.$t('fbb.warehouse.SCP_computation', { defaultValue: '是否参与SCP运算'}),
                                key: "scpEnable",
                                tag: "vRadio",
                                default: scpEnable,
                                span: 24,
                                options: [
                                    {
                                        label: this.$t('boss.purchase.correct', { defaultValue: '是'}),
                                        trueValue: "Y"
                                    },
                                    {
                                        label: this.$t('boss.purchase.deny', { defaultValue: '否'}),
                                        trueValue: "N"
                                    }
                                ]
                            },
                            {
                                label: this.$t('fbb.warehouse.previous_order', { defaultValue: '是否为前打单'}),
                                key: "isLabelBefore",
                                tag: "vRadio",
                                default: isLabelBefore,
                                span: 24,
                                options: [
                                    {
                                        label: this.$t('boss.purchase.correct', { defaultValue: '是'}),
                                        trueValue: "1"
                                    },
                                    {
                                        label: this.$t('boss.purchase.deny', { defaultValue: '否'}),
                                        trueValue: "0"
                                    }
                                ]
                            },
                            {
                                label: this.$t('fbb.warehouse.upload_attachments', { defaultValue: '是否上传附件'}),
                                key: "isAttachHandling",
                                tag: "vRadio",
                                default: isAttachHandling,
                                span: 24,
                                options: [
                                    {
                                        label: this.$t('boss.purchase.correct', { defaultValue: '是'}),
                                        trueValue: "1"
                                    },
                                    {
                                        label: this.$t('boss.purchase.deny', { defaultValue: '否'}),
                                        trueValue: "0"
                                    }
                                ]
                            },
                            {
                                label: this.$t('fbb.warehouse.Priority_shipment', { defaultValue: '发货优先级'}),
                                key: "shipPriority",
                                tag: "vInputNumber",
                                span: 22,
                                default: shipPriority,
                                props: {
                                    min: 0,
                                    math: "round",
                                },
                            },
                            {
                                label: this.$t('fbb.warehouse.Docking_parameters', { defaultValue: '对接参数'}),
                                key: "apiParams",
                                tag: "Input",
                                span: 22,
                                default:apiParams,
                                props:{
                                    disabled:apiParams?true:false
                                },
                            },
                        ],
                        ajaxRequest: HttpWarehouseListEditConfig,
                    };
                    break;
                case "export":
                    this.handleWebfs(
                        // HttpExportManageWare,
                        process.env.VUE_APP_APIURL_FBB + '/api/v2/organizationWarehouse/batchExport',
                        this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, } = row;
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: "查看" }),
                    params: id,
                    operate: 'query',
                    show: this.handleAuth("fbb.clientwarehouse.view")
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: "编辑" }),
                    params: id,
                    operate: "edit",
                    show: this.handleAuth("fbb.clientwarehouse.edit"),
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getSysAllList']),
        getWarehouseTypes() {
            return [
                {
                    value: '1',
                    label: 'Service Warehouse',
                    text: this.$t('fbb.basicdata.warehouse_type_service_remark', { defaultValue: '记录库存流水，库存根据单据产生变动' })
                },
                {
                    value: '2',
                    label: this.$t('fbb.warehouse.fba_warehouse', { defaultValue: 'FBA仓' }),
                },
                // {
                //     value: '4',
                //     label: this.$t('fbb.warehouse.onsite_warehouse', { defaultValue: 'onsite仓库'}),
                // },
                {
                    value: '5',
                    label: 'Virtual Warehouse',
                    text: this.$t('fbb.basicdata.warehouse_type_virtual_remark', { defaultValue: '记录库存流水，但可用库存及预留库存不根据单据变动' })
                },
                {
                    value: '6',
                    label: 'Transfer Warehouse',
                    text: null
                }
            ]
        },
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    show: this.handleAuth("fbb.clientwarehouse.export")
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
                    key: 'CN_title',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.warehouse.warehouse_code', { defaultValue: "仓库代码" }),
                    key: 'CN_code',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.inbound.warehouse_type', { defaultValue: "仓库类型" }),
                    key: 'EQ_warehouseType',
                    tag: 'vSelect',
                    show: true,
                    options: this.getWarehouseTypes,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: "IN_active",
                    tag: "vSelect",
                    options: [
                        {
                            label: "Active",
                            value: 1
                        },
                        {
                            label: "Inactive",
                            value: 0
                        }
                    ],
                    show: true,
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operate', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.inbound.warehouse_type', { defaultValue: "仓库类型" }),
                    key: 'warehouseType',
                    render: (h, { row }) => this.findRenderLabel(this.getWarehouseTypes, row.warehouseType),
                },
                {
                    title: this.$t('fbb.warehouse.warehouse_name', { defaultValue: "仓库名称" }),
                    key: 'title',
                },
                {
                    title: this.$t('fbb.warehouse.warehouse_code', { defaultValue: "仓库代码" }),
                    key: 'code',
                    render: (h, { row }) => {
                        if (this.handleAuth("fbb.clientwarehouse.view")) {
                            return (
                                <div>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.code || '--'}</a>
                                    <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                                </div>
                            );
                        }
                        else {
                            return row.code || '--';
                        }

                    }
                },
                {
                    title: this.$t('fbb.warehouse.owner_org', { defaultValue: "所属管理方" }),
                    key: "hostOrg"
                    // key: "hostOrgId",
                    // render: (h, { row }) => {
                    //     let orgItem = this.getSysAllList.filter(item => {
                    //         return item.value == row.hostOrgId;
                    //     })[0];
                    //     return orgItem.label || "--";
                    //     // return this.$store.state.organization.name
                    // }
                },
                // {
                //     title: this.$t('fbb.warehouse.status', { defaultValue: "活动状态" }),
                //     key: "active",
                //     render: (h, { row }) => this.findRenderLabel(this.getWarehouseActive, row.active),
                // },
                // {
                //     title: this.$t('fbb.warehouse.property', { defaultValue: "仓库属性" }),
                //     key: 'property',
                //     render: (h, { row }) => {
                //         const result = [];
                //         const propertys = (row.property || '').split('|');
                //         this.getWarehouseAttrs.forEach(item => {
                //             if (propertys.some(val => val == item.value)) {
                //                 result.push(item.label);
                //             }
                //         })
                //         return result.join('，');
                //     },
                // },
                // {
                //     title: this.$t('global.common.currency', { defaultValue: "币种" }),
                //     key: 'currencyDefault',
                // },
                // {
                //     title: this.$t('fbb.accountmanage.description', { defaultValue: "描述" }),
                //     key: 'description',
                // },
                // {
                //     title: this.$t('fbb.warehouse.closing_time', { defaultValue: "截单时间（UTC）" }),
                //     key: 'closingTime',
                // },
                // {
                //     title: this.$t('fbb.adjustment.created_name', { defaultValue: "创建人" }),
                //     key: 'createdName',
                // },
                // {
                //     title: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                //     key: 'createdAt',
                // }
                {
                    title: this.$t('fbb.headlogistics.warehouse_address', { defaultValue: '仓库地址' }),
                    key: "address",
                    render: (h, { row }) => {
                        return row.address || "--";
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: "active",
                    render: (h, { row }) => {
                        return row.active ? "Active" : "Inactive";
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: "updatedAt"
                }
            ];
        }
    },
};




